import React, { useEffect } from "react"
import InputNumber from "../../../components/atoms/InputNumber.atom"
import IconWithTooltip from "../../../components/molecules/IconWithTooltip.molecule"

/**
 * @typedef {import("primereact/checkbox").CheckboxProps & { label: string }} InputCheckboxProps
 */

/**
 * Componente de checkbox para formularios
 * @param {InputCheckboxProps} props
 * @returns
 */
export function VacationDaysCounter({
  label,
  usedDays,
  onChangeUsedDays,
  availableDays,
  maxDaysToUse,
  minDaysToUse = 0,
  className = "",
}) {
  const ref = React.useRef(null)
  useEffect(() => {
    if (!ref.current) return
    const inputNumberElement = ref.current.getElement?.()

    const decrementButton = inputNumberElement?.querySelector(
      ".vacation-days-counter__button--decrement"
    )
    const incrementButton = inputNumberElement?.querySelector(
      ".vacation-days-counter__button--increment"
    )

    if (usedDays <= minDaysToUse) {
      decrementButton?.setAttribute("disabled", "true")
    } else {
      decrementButton?.removeAttribute("disabled")
    }

    if (usedDays >= maxDaysToUse) {
      incrementButton?.setAttribute("disabled", "true")
    } else {
      incrementButton?.removeAttribute("disabled")
    }
  }, [usedDays, minDaysToUse, maxDaysToUse])
  return (
    <div className={`vacation-days-counter ${className}`}>
      <label className="vacation-days-counter__label">{label}</label>
      <InputNumber
        ref={ref}
        value={usedDays}
        onValueChange={onChangeUsedDays}
        max={maxDaysToUse}
        min={minDaysToUse}
        showButtons
        buttonLayout="horizontal"
        step={1}
        inputClassName="vacation-days-counter__input text-center"
        decrementButtonClassName={`vacation-days-counter__button vacation-days-counter__button--decrement ${usedDays === 0 ? "vacation-days-counter__button--disabled " : ""}`}
        incrementButtonClassName={`vacation-days-counter__button vacation-days-counter__button--increment ${usedDays === maxDaysToUse ? "vacation-days-counter__button--disabled disabled" : ""}`}
        decrementButtonIcon="pi pi-minus"
        incrementButtonIcon="pi pi-plus"
      />
      <label
        className={`vacation-days-counter__available-days ${availableDays < 0 ? "vacation-days-counter__available-days--error" : ""}`}
      >
        Disponibles: {availableDays}
         {label === "Cubeta" && (
          <span className="span-tooltip">
          <IconWithTooltip
             tooltipValue={`Puedes quedar con -3 días cubeta`}
            position="right"
             
          />
          </span>
        )}
      </label>
    </div>
  )
}
